import { ThemeOptions } from "@mui/material"

const commonTypography = {
    fontFamily: 'Juli, sans-serif',
}

export const typography: ThemeOptions['typography'] = {
    fontFamily: [
        'Juli',
        'Juli Sans',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    h1: {
        ...commonTypography,
        fontWeight: 700,
    },
    h2: {
        ...commonTypography,
        fontWeight: 600,
    },
    h3: {
        ...commonTypography,
        fontWeight: 600,
    },
    h4: {
        ...commonTypography,
        fontWeight: 500,
        fontSize: 26,
        lineHeight: 1.2,
        letterSpacing: 0,
    },
    h5: {
        ...commonTypography,
        fontWeight: 500,
        fontSize: 22,
        lineHeight: "120%",
    },
    h6: {
        ...commonTypography,
        fontWeight: 500,
        fontSize: 18,
        lineHeight: "128%"
    },
    body1: {
        ...commonTypography,
        fontWeight: 400,
        fontSize: 16,
        lineHeight: "148%",
        color: "#000",
    },
    body2: {
        ...commonTypography,
        fontWeight: 400,
        fontSize: 15,
        lineHeight: "148%",
    },
    button: {
        ...commonTypography,
        fontWeight: 500,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "148%",
        letterSpacing: 0,
    },
    caption: {
        ...commonTypography,
        fontWeight: 400,
    },
    overline: {
        ...commonTypography,
        fontWeight: 400,
    },
}

export const fontFamily = `
    @font-face {
        font-family: 'Juli';
        font-style: normal;
        font-display: swap;
        font-weight: 400;
        src: local('Juli'), local('Juli-Regular'), url(https://cdn.koop.sk/fonts/julisans-regular-webfont.woff2?v=2) format('woff2');
        unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
    }
    @font-face {
        font-family: 'Juli';
        font-style: medium;
        font-display: swap;
        font-weight: 500;
        src: local('Juli'), local('Juli-Medium'), url(https://cdn.koop.sk/fonts/julisans-medium-webfont.woff2?v=2) format('woff2');
        unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
    }
    @font-face {
        font-family: 'Juli';
        font-style: normal;
        font-display: swap;
        font-weight: 700;
        src: local('Juli'), local('Juli-Bold'), url(https://cdn.koop.sk/fonts/julisans-bold-webfont.woff2?v=2) format('woff2');
        unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
    }
`;